<div>
  <router-outlet />
</div>
